import React from "react";
import { Redirect } from "react-router-dom";
import Logout from "../../components/login/Logout";
import PasswordReset from "../../components/login/PasswordReset";
import ChangePassword from "../../components/login/ChangePassword";
import Dashboard from "../../components/dashboard/Dashboard";
import "../../state/mocks/auth";

const routes = [
  {
    exact: true,
    path: "/logout",
    component: Logout
  },
  {
    exact: true,
    path: "/dashboard",
    component: Dashboard,
    authorize: true
  },
  {
    exact: true,
    path: "/",
    render: () => <Redirect to="/dashboard" />,
    authorize: true
  },
  {
    exact: true,
    path: "/index.html",
    render: () => <Redirect to="/dashboard" />,
    authorize: true
  },
  {
    exact: true,
    path: "/password-reset",
    component: PasswordReset
  },
  {
    exact: true,
    path: "/change-pass",
    component: ChangePassword
  }
];

export default routes;
